
import Vue, { VNode } from "vue";
import { CreateElement } from "vue/types/umd";
import AppExtraUsers from "./CompanyEditSubscriptionModuleMetaDataExtraUsers.vue";
import AppExtraDossiers from "./CompanyEditSubscriptionModuleMetaDataExtraDossiers.vue";
import AppMaxDocuments from "./CompanyEditSubscriptionModuleMetaDataMaxDocuments.vue";
import AppApiAccess from "./CompanyEditSubscriptionModuleMetaDataApiKeys.vue";
import { PlanModule } from "@/models/plan-module";

export default Vue.extend({
	props: {
		value: {
			type: Object as ()=>PlanModule,
			required: true
		},
	},
	components: {
		AppExtraUsers,
		AppExtraDossiers,
		AppMaxDocuments,
		AppApiAccess,
	},
	render(createElement:CreateElement):VNode {
		return createElement(`app-${this.value.getEditMetaDataComponent()}`, {props: {value: this.value}, on: {close: ()=>this.$emit("close")}});
	}
});
